// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-row[data-v-01c1ce30]{display:flex;justify-content:center;align-items:center;position:relative;width:100vw;margin-left:calc(50% - 50vw)}.article-row__container[data-v-01c1ce30]{width:100%;z-index:1}@media (max-width:959px){.article-row[data-v-01c1ce30]{height:auto;height:var(--row-height-mobile,auto)}}@media (min-width:960px){.article-row[data-v-01c1ce30]{height:auto;height:var(--row-height-desktop,auto)}}", ""]);
// Exports
module.exports = exports;
